/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Stateofcontactrequest3Inputs */

const de__field_stateofcontactrequest3 = /** @type {(inputs: _Field_Stateofcontactrequest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status der Gesprächsanfrage`)
};

/**

* @param {_Field_Stateofcontactrequest3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_stateofcontactrequest3 = /** @type {((inputs?: _Field_Stateofcontactrequest3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Stateofcontactrequest3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_stateofcontactrequest3(inputs)
});
export { _field_stateofcontactrequest3 as "_field_stateOfContactRequest" }